import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-logged-index',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './not-logged-index.component.html',
  styleUrl: './not-logged-index.component.scss'
})
export class NotLoggedIndexComponent {
  faqs = [
    {
      pergunta: 'Estou começando a estudar agora, o site de questões vai me ajudar?',
      resposta: 'Sim. O site foi desenvolvido para ser simples e completo. Simples porque ele é fácil de usar e completo porque deixará você à frente dos seus concorrentes que também estão começando a estudar.',
      visivel: false
    },
    {
      pergunta: 'Tem questões da minha banca?',
      resposta: 'Reunimos centenas de questões de diversas bancas para você. No entanto, algumas bancas pequenas não disponibilizam provas e consequentemente não haverá questões cadastradas.',
      visivel: false
    },
    {
      pergunta: 'Posso filtrar questões por nível de dificuldade?',
      resposta: 'Sim. Você pode escolher resolver apenas questões fáceis, médias ou difíceis.',
      visivel: false
    },
    {
      pergunta: 'As questões são atualizadas?',
      resposta: 'Sim. Diariamente são inseridas novas questões de provas. Assim você tem acesso às provas mais recentes.',
      visivel: false
    },
    {
      pergunta: 'Tenho acesso durante quanto tempo?',
      resposta: 'Os alunos têm acesso por 1 mês ou 1 ano a partir do plano escolhido.',
      visivel: false
    }
  ];

  toggleResposta(index: number): void {
    this.faqs[index].visivel = !this.faqs[index].visivel;
  }
}
